import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import useStyles from './styles';

const MotiveTitle = ({ ...props }) => {
  const { icon, subtitle, title } = props;
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <div style={{ textAlign: 'center' }}>
        <img className={classes.icon} src={icon} />
        <span className={classes.title}>{title}</span>
      </div>

      <Typography align="center" variant="h5" className={classes.subtitle}>
        {subtitle}
      </Typography>
    </Box>
  );
};

MotiveTitle.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default MotiveTitle;
